export enum Environment {
	TEST = 'test',
	UAT = 'uat',
	LIVE = 'live'
}
